module.exports = __webpack_public_path__ + "static/battle_smith_2-1015cc0cddd780b61b49cd1ec1242346.png";